/**
 * Qué textos enseña la card de suscripción, por variante.
 *
 * La card tiene DOS juegos de copys que no son intercambiables: el de 1 local
 * («Responde cada reseña…», «Ficha de Google») y el de varios («Responde las
 * reseñas de todos tus locales…», «Fichas de Google»). Los dicta el diseño
 * (`temp_docs/CardBusiness.html`) y no son el mismo texto con un plural: cambian
 * las viñetas, su orden y hasta los grupos.
 *
 * Aquí solo viven las CLAVES; el texto está en `locales/<lang>/translation.json`.
 * Están en un módulo aparte para que `cardI18n.test.js` las recorra sin tener
 * que adivinarlas con un regex sobre el JSX.
 */

const P = 'billing.sub';

/** Las tres viñetas de cabecera. Llevan `<b>`: van por `<Trans>`. */
export const HIGHLIGHTS = {
  single: [`${P}.single.h1`, `${P}.single.h2`, `${P}.single.h3`],
  multi: [`${P}.multi.h1`, `${P}.multi.h2`, `${P}.multi.h3`],
};

/** «Todo lo que incluye»: cuatro grupos con su título y sus viñetas. */
export const GROUPS = {
  single: [
    { title: `${P}.group.reviews`, items: [`${P}.single.reviews.b1`, `${P}.single.reviews.b2`, `${P}.single.reviews.b3`] },
    { title: `${P}.group.seo`, items: [`${P}.single.seo.b1`, `${P}.single.seo.b2`] },
    { title: `${P}.group.profileSingle`, items: [`${P}.single.profile.b1`] },
    { title: `${P}.group.competition`, items: [`${P}.single.competition.b1`, `${P}.single.competition.b2`] },
  ],
  multi: [
    { title: `${P}.group.reviews`, items: [`${P}.single.reviews.b1`, `${P}.multi.reviews.b2`, `${P}.single.reviews.b3`] },
    { title: `${P}.group.seo`, items: [`${P}.multi.seo.b1`, `${P}.multi.seo.b2`] },
    { title: `${P}.group.profileMulti`, items: [`${P}.multi.profile.b1`, `${P}.multi.profile.b2`] },
    { title: `${P}.group.competition`, items: [`${P}.multi.competition.b1`, `${P}.single.competition.b2`] },
  ],
};

/** La lista larga de la columna Business de la web de precios. Lleva `<b>`. */
export const WEB_GROUPS = [
  { title: `${P}.group.reviews`, items: [`${P}.web.reviews.b1`, `${P}.web.reviews.b2`, `${P}.web.reviews.b3`] },
  { title: `${P}.group.seo`, items: [`${P}.web.seo.b1`, `${P}.web.seo.b2`] },
  { title: `${P}.group.profileMulti`, items: [`${P}.web.profile.b1`, `${P}.web.profile.b2`, `${P}.web.profile.b3`] },
  { title: `${P}.group.delegate`, items: [`${P}.web.delegate.b1`, `${P}.web.delegate.b2`] },
];

/** Todas las claves de los catálogos de arriba, para el test de i18n. */
export function catalogKeys() {
  const keys = new Set([...HIGHLIGHTS.single, ...HIGHLIGHTS.multi]);
  for (const g of [...GROUPS.single, ...GROUPS.multi, ...WEB_GROUPS]) {
    keys.add(g.title);
    g.items.forEach((k) => keys.add(k));
  }
  return [...keys];
}
